// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dark theme for layers panel */
.layers-panel {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 350px;
  background-color: rgba(33, 37, 41, 0.95);
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  z-index: 1000;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  color: #ffffffa3;
  max-height: calc(100vh - 20px);
}

.layers-panel-header {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
}

.close-btn {
  background: none;
  border: none;
  color: #fff;
  font-size: 24px;
  cursor: pointer;
  padding: 5px;
  opacity: 0.8;
  transition: opacity 0.2s;
}

.close-btn:hover {
  opacity: 1;
}

.layers-panel-content {
  padding: 0;
  flex: 1;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
}

/* Dark scrollbar styles */
.layers-panel-content::-webkit-scrollbar {
  width: 8px;
}

.layers-panel-content::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}

.layers-panel-content::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 4px;
}

.layers-panel-content::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.4);
}

/* Firefox scrollbar styles */
.layers-panel-content {
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.3) rgba(255, 255, 255, 0.1);
}

.layer-section {
  padding: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.layer-section h4 {
  margin: 0;
  padding: 7px 15px;
  font-size: 14px;
  font-weight: 500;
  background-color: rgba(255, 255, 255, 0.05);
  color: #fff;
}

.layer-list {
  list-style: none;
  margin: 0;
  padding: 10px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

.layer-item {
  padding: 10px;
  cursor: pointer;
  font-size: 13px;
  transition: background-color 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 6px;
  text-align: center;
}

.layer-item:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.layer-item.active {
  background-color: rgba(52, 152, 219, 0.3);
  color: #fff;
}

/* Alert items styling */
.layer-section:last-child .layer-item {
  color: rgba(255, 99, 71, 0.6); /* Tomato red with 0.6 opacity */
}

.layer-section:last-child .layer-item:hover {
  background-color: rgba(255, 99, 71, 0.15);
}

.layer-section:last-child .layer-item label {
  color: rgba(255, 99, 71, 0.6);
}

.layer-section:last-child .layer-icon {
  color: rgba(255, 99, 71, 0.6);
}

.layer-icon {
  font-size: 24px;
  margin-bottom: 5px;
}

.layer-text {
  font-size: 12px;
}

.layer-item label {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  cursor: pointer;
  color: #ffffffa3;
  font-size: 13px;
}

.layer-item input[type="checkbox"] {
  margin: 5px 0;
}

.opacity-control {
  padding: 10px 15px;
  display: flex;
  align-items: center;
  gap: 10px;
  pointer-events: auto;
}

.opacity-slider {
  flex: 1;
  height: 4px;
  -webkit-appearance: none;
  background: #ddd;
  border-radius: 2px;
  outline: none;
  pointer-events: auto;
}

.opacity-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 16px;
  height: 16px;
  background: #2c3e50;
  border-radius: 50%;
  cursor: pointer;
  transition: background 0.2s;
  pointer-events: auto;
}

.opacity-slider::-webkit-slider-thumb:hover {
  background: #34495e;
}

.opacity-value {
  min-width: 40px;
  text-align: right;
  font-size: 12px;
  color: #fff;
  pointer-events: none;
}

@media (max-width: 768px) {
  .layers-panel {
    width: 300px;
  }
  
  .layer-item {
    width: calc(50% - 10px);
  }
}

@media (max-width: 480px) {
  .layers-panel {
    width: 250px;
  }
  
  .layer-item {
    width: calc(100% - 10px);
  }
}

.prevent-map-events {
  pointer-events: none;
}

.layers-panel-content {
  pointer-events: auto;
} `, "",{"version":3,"sources":["webpack://./src/components/MapLayers.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,OAAO;EACP,gBAAgB;EAChB,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA,0BAA0B;AAC1B;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,6BAA6B;AAC7B;EACE,qBAAqB;EACrB,kEAAkE;AACpE;;AAEA;EACE,UAAU;EACV,iDAAiD;AACnD;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,2CAA2C;EAC3C,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;EACzC,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,6BAA6B,EAAE,gCAAgC;AACjE;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,OAAO;EACP,WAAW;EACX,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB","sourcesContent":["/* Dark theme for layers panel */\n.layers-panel {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  width: 350px;\n  background-color: rgba(33, 37, 41, 0.95);\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);\n  z-index: 1000;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  color: #ffffffa3;\n  max-height: calc(100vh - 20px);\n}\n\n.layers-panel-header {\n  display: flex;\n  justify-content: flex-end;\n  padding: 10px;\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  color: #fff;\n  font-size: 24px;\n  cursor: pointer;\n  padding: 5px;\n  opacity: 0.8;\n  transition: opacity 0.2s;\n}\n\n.close-btn:hover {\n  opacity: 1;\n}\n\n.layers-panel-content {\n  padding: 0;\n  flex: 1;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n}\n\n/* Dark scrollbar styles */\n.layers-panel-content::-webkit-scrollbar {\n  width: 8px;\n}\n\n.layers-panel-content::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 4px;\n}\n\n.layers-panel-content::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.3);\n  border-radius: 4px;\n}\n\n.layers-panel-content::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.4);\n}\n\n/* Firefox scrollbar styles */\n.layers-panel-content {\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.3) rgba(255, 255, 255, 0.1);\n}\n\n.layer-section {\n  padding: 0;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.layer-section h4 {\n  margin: 0;\n  padding: 7px 15px;\n  font-size: 14px;\n  font-weight: 500;\n  background-color: rgba(255, 255, 255, 0.05);\n  color: #fff;\n}\n\n.layer-list {\n  list-style: none;\n  margin: 0;\n  padding: 10px;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 10px;\n}\n\n.layer-item {\n  padding: 10px;\n  cursor: pointer;\n  font-size: 13px;\n  transition: background-color 0.2s;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  border-radius: 6px;\n  text-align: center;\n}\n\n.layer-item:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.layer-item.active {\n  background-color: rgba(52, 152, 219, 0.3);\n  color: #fff;\n}\n\n/* Alert items styling */\n.layer-section:last-child .layer-item {\n  color: rgba(255, 99, 71, 0.6); /* Tomato red with 0.6 opacity */\n}\n\n.layer-section:last-child .layer-item:hover {\n  background-color: rgba(255, 99, 71, 0.15);\n}\n\n.layer-section:last-child .layer-item label {\n  color: rgba(255, 99, 71, 0.6);\n}\n\n.layer-section:last-child .layer-icon {\n  color: rgba(255, 99, 71, 0.6);\n}\n\n.layer-icon {\n  font-size: 24px;\n  margin-bottom: 5px;\n}\n\n.layer-text {\n  font-size: 12px;\n}\n\n.layer-item label {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  cursor: pointer;\n  color: #ffffffa3;\n  font-size: 13px;\n}\n\n.layer-item input[type=\"checkbox\"] {\n  margin: 5px 0;\n}\n\n.opacity-control {\n  padding: 10px 15px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  pointer-events: auto;\n}\n\n.opacity-slider {\n  flex: 1;\n  height: 4px;\n  -webkit-appearance: none;\n  background: #ddd;\n  border-radius: 2px;\n  outline: none;\n  pointer-events: auto;\n}\n\n.opacity-slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  width: 16px;\n  height: 16px;\n  background: #2c3e50;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: background 0.2s;\n  pointer-events: auto;\n}\n\n.opacity-slider::-webkit-slider-thumb:hover {\n  background: #34495e;\n}\n\n.opacity-value {\n  min-width: 40px;\n  text-align: right;\n  font-size: 12px;\n  color: #fff;\n  pointer-events: none;\n}\n\n@media (max-width: 768px) {\n  .layers-panel {\n    width: 300px;\n  }\n  \n  .layer-item {\n    width: calc(50% - 10px);\n  }\n}\n\n@media (max-width: 480px) {\n  .layers-panel {\n    width: 250px;\n  }\n  \n  .layer-item {\n    width: calc(100% - 10px);\n  }\n}\n\n.prevent-map-events {\n  pointer-events: none;\n}\n\n.layers-panel-content {\n  pointer-events: auto;\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
